'use client';
import { useHomeFeedFilters } from '@/actions/feed.actions';
import Card from '@ui/Card';
import PostType from 'constants/postType.constants';
import { cx } from 'cva';
import React, { useState } from 'react';
import ChipFilter from '../components/ChipFilter';
import SelectFilter from '../components/SelectFilter';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import { SlidersHorizontal } from 'lucide-react';

const postTypes = [
  {
    label: 'Donate',
    value: PostType.Campaign,
    options: [
      {
        id: 0,
        label: 'Fundraisers',
        value: 'fundraisers',
        parentLabel: 'donate',
      },
      {
        id: 1,
        label: 'In-Kind (Clothes, food, etc.)',
        value: 'inKind',
        parentLabel: 'donate',
      },
    ],
    count: null,
  },
  {
    label: 'Volunteer',
    value: PostType.Volunteering,
    options: [
      {
        id: 0,
        label: 'In-Person',
        value: 'inPerson',
        parentLabel: 'volunteer',
      },
      {
        id: 1,
        label: 'Virtual (Online)',
        value: 'virtual',
        parentLabel: 'volunteer',
      },
    ],
    count: null,
  },
];

const newsTypes = [
  // {
  //   // icon: <SlidersHorizontal className={cx('h-5 w-5 text-text-secondary')} />,
  //   label: 'Volunteer',
  //   value: PostType.Volunteering,
  //   parentLabel: 'volunteer',
  // },
  {
    icon: <SlidersHorizontal className={cx('h-5 w-5 text-text-secondary')} />,
    label: 'Nonprofit News',
    value: PostType.NewsFeeds,
    parentLabel: 'nonProfitNews',
  },
];

function PostFilters() {
  const isLesserThanMediumScreen = useBreakpointHooks((bp) =>
    bp.useSmaller('md'),
  );

  const postType = useHomeFeedFilters((state) => state.postType);
  const setPostType = useHomeFeedFilters((state) => state.setPostType);
  const resetFilters = useHomeFeedFilters((state) => state.resetFilters);

  const [resetAllFilters, setResetAllFilters] = useState(false);

  const handlePostTypeSelection = (type) => {
    setPostType(type);
  };

  const handleReset = () => {
    resetFilters();
    setResetAllFilters(true);
    setTimeout(() => setResetAllFilters(false), 0);
  };

  const handleSingleFilterReset = (type) => {
    if (resetAllFilters) return true;
    if (postType === 'all') return false;
    if (postType !== type) return true;
    return false;
  };

  const renderButton = () => (
    <button
      type="button"
      className="whitespace-nowrap text-14 text-text-primary hover:text-primary"
      onClick={handleReset}>
      Clear all
    </button>
  );

  return (
    <Card
      padding="none"
      className="flex items-center justify-center px-4">
      <div
        className={cx(
          'pt-5 pb-5 flex w-full',
          isLesserThanMediumScreen
            ? 'flex-row items-center justify-start gap-4'
            : 'ml-4 flex-row items-center justify-start gap-7',
        )}>
        {postTypes.map((type) => (
          <SelectFilter
            placeholder={type.label}
            options={type.options}
            key={type.label}
            onCancel={() => {}}
            onApply={() => handlePostTypeSelection(type.value)}
            icon={undefined}
            reset={handleSingleFilterReset(type.value)}
          />
        ))}

        {isLesserThanMediumScreen ? (
          <>
            {newsTypes.map((type) => (
              <SelectFilter
                icon={type.icon}
                options={[type]}
                key={type.label}
                onCancel={() => {}}
                onApply={() => handlePostTypeSelection(type.value)}
                placeholder={type.label}
                reset={handleSingleFilterReset(type.value)}
              />
            ))}
          </>
        ) : (
          <>
            {newsTypes.map((type) => (
              <ChipFilter
                label={type.label}
                value={type.value}
                parentLabel={type.parentLabel}
                key={type.label}
                onToggle={() => handlePostTypeSelection(type.value)}
                reset={handleSingleFilterReset(type.value)}
              />
            ))}
          </>
        )}

        {renderButton()}
      </div>
    </Card>
  );
}

export default React.memo(PostFilters);
